// react
import { useSelector } from 'react-redux';
// utils
import createAvatar from '../utils/createAvatar';
// components
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  // redux-saga
  const { user } = useSelector((state) => state.auth);

  // Get avatar image if exists
  const imgAvatar = user?.images_on_sporeuser?.find(image => image.location === 'PR');

  return (
    <Avatar alt='Avatar' color='default' src={imgAvatar?.image} {...other}>
      {createAvatar(user?.name || user?.email).name}
    </Avatar>
  );
}
